
(function () {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const stopAutoplayVideos = () => {
    if (!reduceMotion.matches) return;
    document.querySelectorAll("video[autoplay]").forEach((video) => {
      video.removeAttribute("autoplay");
      video.pause();
    });
  };
  document.addEventListener("DOMContentLoaded", stopAutoplayVideos);
  if (typeof reduceMotion.addEventListener === "function") {
    reduceMotion.addEventListener("change", stopAutoplayVideos);
  }
})();

document.addEventListener("DOMContentLoaded", () => {
  const faqItems = document.querySelectorAll(".faqrs-item");
  faqItems.forEach(item => {
    const question = item.querySelector(".faqrs-question");
    const answer = item.querySelector(".faqrs-answer");
    if (!question || !answer) return;
    question.addEventListener("click", () => {
      const isActive = item.classList.contains("faqrs-active");
      faqItems.forEach(i => {
        i.classList.remove("faqrs-active");
        const otherAnswer = i.querySelector(".faqrs-answer");
        const otherQuestion = i.querySelector(".faqrs-question");
        if (otherAnswer) otherAnswer.style.maxHeight = null;
        if (otherQuestion) otherQuestion.setAttribute("aria-expanded", "false");
      });
      if (!isActive) {
        item.classList.add("faqrs-active");
        answer.style.maxHeight = answer.scrollHeight + "px";
        question.setAttribute("aria-expanded", "true");
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector(".see-in-action-btn:not([data-modal-id])");
  if (!btn) return;

  btn.addEventListener("click", () => {
    const index = Number(btn.dataset.video) || 0;
    const slides = document.querySelectorAll(".swiper-slide-md video");

    if (slides.length === 0) return;

    const video = slides[index];

    if (!video) return;

    if (typeof video.click === "function") {
      video.click();  
    } else {
      video.play();
    }
  });
});
